import diasSemana from '@/enums/day-of-week';

export default {
  methods: {
    getIntervalCount(empresa) {
      const startTime = this.$moment(empresa.inicioAtendimento, 'HH:mm:ss');
      const end = this.$moment(empresa.fimAtendimento, 'HH:mm:ss');
      return this.$moment.duration(end.diff(startTime))
        .asHours();
    },
    checkInactive(empresa, interval) {
      const map = this.empresa.diasAtendimento
        .map((dia) => diasSemana.keys[dia].value);
      return !map.includes(this.$moment(interval.date)
        .weekday());
    },
    getEventColor(event) {
      if (event.cancelamento) {
        return 'grey';
      }
      return event.color;
    },
  },
};
